/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * Marketplace API
 * OpenAPI spec version: 1.0.0
 */

/**
 * * `alu_dirt` - Alu Dirt
* `bales_alu` - Bales Alu
* `bales_briquette` - Bales Briquette
* `bales_hdpe` - Bales Hdpe
* `bales_loading` - Bales Loading
* `bales_pet` - Bales Pet
* `colour` - Colour
* `count` - Count
* `gdrive_claims_data` - Gdrive Claims Data
* `gdrive_inspection_data` - Gdrive Inspection Data
* `gravimetric_alu` - Gravimetric Alu
* `gravimetric_alu_bale` - Gravimetric Alu Bale
* `gravimetric_alu_weight` - Gravimetric Alu Weight
* `gravimetric_pet` - Gravimetric Pet
* `gravimetric_pet_bale` - Gravimetric Pet Bale
* `gravimetric_pet_weight` - Gravimetric Pet Weight
* `loose_alu` - Loose Alu
* `loose_pet` - Loose Pet
* `other_material` - Other Material
* `pet_dirt` - Pet Dirt
* `sample_manual` - Sample Manual
* `selfserve` - Selfserve
* `site_evidence` - Site Evidence
* `site_material` - Site Material
* `sops` - Sops
* `Test` - Test
* `test_holes` - Test Holes
* `visual_specification` - Visual Specification
* `dev_test` - Dev Test
* `bales_alu_old` - Bales Alu Old
 */
export type EncordFolderEnum = typeof EncordFolderEnum[keyof typeof EncordFolderEnum];


export const EncordFolderEnum = {
  alu_dirt: 'alu_dirt',
  bales_alu: 'bales_alu',
  bales_briquette: 'bales_briquette',
  bales_hdpe: 'bales_hdpe',
  bales_loading: 'bales_loading',
  bales_pet: 'bales_pet',
  colour: 'colour',
  count: 'count',
  gdrive_claims_data: 'gdrive_claims_data',
  gdrive_inspection_data: 'gdrive_inspection_data',
  gravimetric_alu: 'gravimetric_alu',
  gravimetric_alu_bale: 'gravimetric_alu_bale',
  gravimetric_alu_weight: 'gravimetric_alu_weight',
  gravimetric_pet: 'gravimetric_pet',
  gravimetric_pet_bale: 'gravimetric_pet_bale',
  gravimetric_pet_weight: 'gravimetric_pet_weight',
  loose_alu: 'loose_alu',
  loose_pet: 'loose_pet',
  other_material: 'other_material',
  pet_dirt: 'pet_dirt',
  sample_manual: 'sample_manual',
  selfserve: 'selfserve',
  site_evidence: 'site_evidence',
  site_material: 'site_material',
  sops: 'sops',
  Test: 'Test',
  test_holes: 'test_holes',
  visual_specification: 'visual_specification',
  dev_test: 'dev_test',
  bales_alu_old: 'bales_alu_old',
} as const;
